export default __webpack_public_path__ + "static/media/darkMsg.49a4b730.svg";